import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { useTranslation } from 'hooks/useTranslation';
import React, { memo } from 'react';

const FeedbackPopup = () => {
  const { t } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);

  return (
    <>
      <div className="feedback-popup-container">
        <Typography variant={TYPOGRAPHY_VARIANTS.H1}>
          {t('feedbackPopupTitle')}
        </Typography>
        <Typography variant={TYPOGRAPHY_VARIANTS.BODY}>
          {t('feedbackPopupContent')}
        </Typography>
      </div>
    </>
  );
};

export default memo(FeedbackPopup);
